import { filtersMutationKeys } from './constants.js'
import { useMutation } from '@tanstack/react-query'
import api from '../../config/axios-config.jsx'

export const useCreateFilterMutation = (options) => {
  const handleMutationFunction = async ({ filter }) => {
    const config = {
      method: 'post',
      data: filter
    }

    const { data } = await api('/api/filters', config)

    return data
  }

  return useMutation({
    mutationFn: handleMutationFunction,
    mutationKey: [filtersMutationKeys.CREATE_FILTER],
    ...options
  })
}
